import React from 'react';

export const handleWithStopPropagation = (e: React.UIEvent, cb?: Function) => {
  e.stopPropagation();

  if (cb && typeof cb === 'function') {
    cb(e);
  }
};
